<template>
  <v-app>
    <Mensaje :mensaje="mensaje" />
    <router-view />
  </v-app>
</template>

<script>
import Mensaje from "@/components/Mensaje.vue";
import { useMensaje } from "@/composables/useMensaje";

export default {
  name: "App",
  components: { Mensaje },
  setup() {
    const { mensaje } = useMensaje();
    return { mensaje };
  },
};
</script>
